export default {"src":"/_next/static/media/gold-coin-icon.62f91978.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};